import React from "react";
import { formatDate } from "./utils";

const NewsletterTab = ({ newsletter }) => (
  <div className="bg-white border border-line overflow-x-auto" data-testid="admin-newsletter-panel">
    <table className="w-full text-sm min-w-[600px]">
      <thead className="border-b border-line">
        <tr className="text-left">
          <th className="px-4 py-3 overline">Email</th>
          <th className="px-4 py-3 overline">Subscribed</th>
        </tr>
      </thead>
      <tbody>
        {newsletter.length === 0 ? (
          <tr>
            <td colSpan="2" className="px-4 py-8 text-mute text-center">
              No subscribers yet.
            </td>
          </tr>
        ) : (
          newsletter.map((n) => (
            <tr key={n.id} className="border-b border-line">
              <td className="px-4 py-3">{n.email}</td>
              <td className="px-4 py-3 mono text-xs text-mute">{formatDate(n.created_at)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default NewsletterTab;
